export const getToken    = () => localStorage.getItem('referral_token');
export const getStudent  = () => JSON.parse(localStorage.getItem('referral_student') || 'null');
export const getRole     = () => getStudent()?.role || null;
export const isLoggedIn  = () => !!getToken();

export const saveSession = (token, student) => {
  localStorage.setItem('referral_token', token);
  localStorage.setItem('referral_student', JSON.stringify(student));
};

export const logout = () => {
  localStorage.removeItem('referral_token');
  localStorage.removeItem('referral_student');
  window.location.href = '/login';
};
